var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import find from 'lodash/find';
import { isIncludedIn } from "./helpers";
var IncludedIntervalHandler = /** @class */ (function () {
    // { "from": "2020/05/11 11:30", "to": "2020/05/11 11:45", "data": {} }}
    function IncludedIntervalHandler(ranges) {
        this.ranges = ranges;
        // {}
    }
    IncludedIntervalHandler.prototype.getStatus = function (from, to, quantity_left, priority) {
        var theRange = find(this.ranges, function (range) {
            return isIncludedIn(from, to, range.from, range.to);
        });
        if (theRange) {
            var isAvailable = priority >= theRange.priority;
            if (isAvailable) {
                return __assign(__assign({}, theRange), { from: from, to: to, isAvailable: true, name: this.constructor.name });
            }
            return __assign(__assign({}, theRange), { from: from, to: to, isAvailable: false, debug: { from: from, to: to, priority: priority }, reason: "Another slot with higher priority available", name: this.constructor.name, data: {} });
        }
        return {
            isAvailable: false,
            reason: "Slot not included",
            name: this.constructor.name,
            debug: { from: from, to: to },
            data: {}
        };
    };
    return IncludedIntervalHandler;
}());
export { IncludedIntervalHandler };
